import { Component, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from './core/loading/loading.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterModule, LoadingComponent],
    standalone: true
})
export class AppComponent {
  title = 'MAPFOREST';



}
